import {Component, OnInit} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {Location} from "@angular/common";
import {Router} from "@angular/router";

@Component({
    selector: 'app-hostel-fee',
    templateUrl: './hostel-fee.component.html',
    styleUrls: ['./hostel-fee.component.scss']
})
export class HostelFeeComponent implements OnInit {
    currentPath: string;

    constructor(private location: Location) {
        this.currentPath = this.location.path();
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }

    ngOnInit(): void {
    }

}
